















import ripple from "./ripple.vue";
import iconButton from "./iconButtons.vue";
import { Component, Vue, Prop } from "vue-property-decorator";
import {frontendClient} from "../lib/client"

@Component({
    components: {
        ripple,
        iconButton
    }
})
export default class ErrorPrompt extends Vue {

    text:string = "ERROR";
    visible:boolean = false;

    showError(){
        this.visible = true;
    }

    mounted(){
        frontendClient.on("errorPromptMessage", () => {
            this.text = frontendClient.errorPromptMessage;
            if(frontendClient.errorPromptMessage == null){
                this.visible = false;
            }else{
                this.visible = true;
            }
        })
    }

    closePrompt(){
        frontendClient.clearError();
    }

}

